import {
  ComponentDescriptor,
  getRendererFromDescriptor,
  IProduct,
} from '@kizi/comparator-core';
import { Div, DivProps, Label, Span } from '@kizi/core-components';
import React, { MouseEventHandler, useRef, useState } from 'react';
import { isNil } from 'lodash';
import { Window, WindowProps } from '../Window';

export interface AdditionalInfoProps extends DivProps {
  label?: string;
  onLabelClick?: MouseEventHandler;
  path?: string;
  value?: string;
  measure: string;
  windowProps?: Omit<WindowProps, 'show' | 'onClose'>;
  component?: ComponentDescriptor;
  data?: IProduct;
}

export const AdditionalInfo: React.FC<AdditionalInfoProps> = ({
  label,
  onLabelClick,
  value,
  measure,
  windowProps,
  data,
  component,
  ...restProps
}: AdditionalInfoProps) => {
  const [show, setShow] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);
  if (isNil(value)) {
    return null;
  }
  return (
    <Div {...restProps} variant="priceMedium" ref={divRef}>
      <Div
        onClick={onLabelClick ? (e) => onLabelClick(e) : () => setShow(true)}
        style={{
          cursor: onLabelClick !== undefined || windowProps ? 'pointer' : '',
        }}
      >
        <Span>{value}</Span>
        <Span>{` ${measure}`}</Span>
      </Div>
      {label && (
        <Label
          display="block"
          onClick={onLabelClick ? (e) => onLabelClick(e) : () => setShow(true)}
          style={{
            cursor: onLabelClick !== undefined || windowProps ? 'pointer' : '',
          }}
          variant="paragraphs.captionRegularSmall"
        >
          {label}
        </Label>
      )}
      {windowProps && (
        <Window
          {...windowProps}
          show={show}
          popoverProps={{
            ...windowProps.popoverProps,
            attachTo: divRef.current,
          }}
          onClose={() => setShow(false)}
        >
          {component
            ? (getRendererFromDescriptor({
                ...component,
                props: {
                  ...component['props'],
                  data,
                },
              }) as React.ReactChild)
            : windowProps.children}
        </Window>
      )}
    </Div>
  );
};
